__turbopack_context__.v({
  "dangerousHTML": "[video]-module-scss-module__12psmG__dangerousHTML",
  "h1": "[video]-module-scss-module__12psmG__h1",
  "h2": "[video]-module-scss-module__12psmG__h2",
  "h3": "[video]-module-scss-module__12psmG__h3",
});
